module.exports = __webpack_public_path__ + "static/media/marketing-landscape.70396d29.jpg";